import * as React from "react";
import { Question } from "./Question";
import { Link } from "react-router-dom";

const NUMBER_OF_QUESTIONS_AVAILABLE = 500;
const NUMBER_OF_QUESTIONS_PER_TEST = 20;

export const Test = (): React.JSX.Element => {
  const [currentQuestion, setCurrentQuestion] = React.useState(0);
  const [score, setScore] = React.useState(0);
  const questionSet = React.useRef(() => {
    const arr = Array.from(
      { length: NUMBER_OF_QUESTIONS_AVAILABLE },
      (e, i) => i,
    );
    const shuffledQuestions = arr.sort(() => 0.5 - Math.random());
    const trimmedQuestions = shuffledQuestions.slice(
      0,
      NUMBER_OF_QUESTIONS_PER_TEST,
    );
    console.log("trimmedQuestions", trimmedQuestions);
    return trimmedQuestions;
  });
  const currentQuestionIndex = questionSet.current()[currentQuestion];
  return (
    <div>
      <h3>
        <div>
          Question {currentQuestion + 1} of {NUMBER_OF_QUESTIONS_PER_TEST}
        </div>
        <div>Score so far: {score}</div>
      </h3>
      {currentQuestion < NUMBER_OF_QUESTIONS_PER_TEST && (
        <Question
          questionNumber={currentQuestionIndex}
          handleResponse={(wasCorrect: boolean) => {
            if (wasCorrect) {
              setScore(score + 1);
            }
            setCurrentQuestion(currentQuestion + 1);
          }}
        />
      )}
      {currentQuestion >= NUMBER_OF_QUESTIONS_PER_TEST && (
        <div>
          <h2>Test Complete!</h2>
          <p>
            You scored {score} out of {NUMBER_OF_QUESTIONS_PER_TEST}.
          </p>
          <p>
            Click <Link to="/home">here</Link> to return to the home page.
          </p>
        </div>
      )}
    </div>
  );
};
